export const GET_CATEGORIES = 'GET_CATEGORIES'
export const SET_CATEGORY_DETAIL = 'SET_CATEGORY_DETAIL'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
